import { __decorate } from "tslib";
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { localized } from '@lit/localize';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { phoneStyles } from './phone.styles.js';
let HlxPhone = class HlxPhone extends HelixElement {
    render() {
        return html `
            <span></span>
        `;
    }
};
HlxPhone.styles = [componentStyles, phoneStyles];
HlxPhone = __decorate([
    customElement('hlx-phone'),
    localized()
], HlxPhone);
export { HlxPhone };
//# sourceMappingURL=phone.js.map